(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "normalizr", "../setting", "../../user/schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("normalizr"), require("../setting"), require("../../user/schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.normalizr, global.setting, global.schema);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _normalizr, _setting, _schema) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.notificationsSchema = _exports.notificationSchema = void 0;

  /**
   * Schema for a single notification
   * @type {schema.Entity}
   */
  var notificationSchema = new _normalizr.schema.Entity(_setting.notificationEntityKey, {
    sender: _schema.userSchema
  });

  /**
   * Schema for multiple notifications
   * @type {Array<schema.Entity>}
   */
  _exports.notificationSchema = notificationSchema;
  var notificationsSchema = [notificationSchema];
  _exports.notificationsSchema = notificationsSchema;
});